const UNITS = [
  ["year", 365 * 24 * 60 * 60],
  ["month", 30 * 24 * 60 * 60],
  ["day", 24 * 60 * 60],
  ["hour", 60 * 60],
  ["minute", 60],
];

export const bellTimeAgo = (date, now = Date.now()) => {
  const then = new Date(date).getTime();
  if (!Number.isFinite(then)) return "";
  const seconds = Math.floor((now - then) / 1000);
  if (seconds < 60) return "Just now";
  for (const [unit, size] of UNITS) {
    const count = Math.floor(seconds / size);
    if (count >= 1) {
      return `${count} ${unit}${count === 1 ? "" : "s"} ago`;
    }
  }
  return "Just now";
};
